// 以下代码是一些常量命名 --------------------
import { axios, getHeader } from "./axios";
import md5 from "crypto-js/md5";
import Base64 from "crypto-js/enc-base64";
import createAuthorization from "./authorization";

var host = "https://upload.xueersi.com";

var fetch = {
  axiosGet: function (url, params) {
    axios
      .get(url, {
        params: params.data ? params.data : {},
      })
      .then(function (res) {
        params.success ? params.success(res) : function () {};
      })
      .catch(function (fail) {
        params.fail ? params.fail(fail) : function () {};
      });
  },
  axiosPost: function (url, params) {
    const authorizationHeader = {
      "x-tss-security-token": params.securityToken,
      "x-tss-date": new Date().toGMTString(),
    };
    const authorization = createAuthorization(
      url,
      "POST",
      params,
      authorizationHeader,
    );
    let headers = {
      ...authorizationHeader,
      Authorization: authorization,
      // ...getHeader(),
    };
    const { success, fail: failFn } = params;
    axios({
      url: host + url,
      method: "post",
      headers,
      data: params.params || {},
    })
      .then(function (res) {
        success && success(res);
      })
      .catch(function (fail) {
        failFn && failFn(fail);
      });
  },
  axiosPut: function (url, params, headers) {
    if (!params.data) {
      throw new Error("invalid parmas.data");
    }
    let authorizationHeader = {
      "x-tss-date": new Date().toGMTString(),
      "x-tss-security-token": params.securityToken,
    };

    const authorization = createAuthorization(
      url,
      "PUT",
      params,
      authorizationHeader,
    );

    let header = {
      ...authorizationHeader,
      Authorization: authorization,
    };

    var checkMd5 = params.data.checkMd5 || false;
    if (checkMd5) {
      md5(message);
      var contentMD5 = md5(params.data.body);
      header["Content-MD5"] = Base64.stringify(contentMD5);
    }
    const { success, fail: failFn } = params;
    axios({
      url: host + url,
      method: "put",
      headers: header,
      data: params.data.body,
    })
      .then(function (res) {
        success && success(res);
      })
      .catch(function (fail) {
        failFn && failFn(fail);
      });
  },
};

export default fetch;
